import React, { useMemo } from 'react'
import s from './styles/InactiveColumns.module.scss'
import { useInactiveColumns } from './hooks/useInactiveColumns'
import { ReactComponent as TitleIcon } from 'assets/icons/inactive_icon.svg'
import Switch from 'shared/ui/Switch/Switch'

export default function InactiveColumns({
	items = [],
	onActivate,
	forceOpenSignal = 0,
}) {
	const isDisabled = useMemo(() => (items?.length || 0) === 0, [items])
	const { isOpen, onToggle } = useInactiveColumns({
		initialOpen: true,
		isDisabled,
		forceOpenSignal,
	})

	return (
		<div className={`${s.wrap} ${isDisabled ? s.disabled : ''}`}>
			<button
				type="button"
				className={s.head}
				onClick={onToggle}
				aria-expanded={isOpen}
				aria-disabled={isDisabled}
				disabled={isDisabled}
			>
				<div className={s.title}>
					<div className={s.title__icon}>
						<TitleIcon />
					</div>
					<span className={s.title__text}>Inactive Columns</span>
				</div>

				<div className={`${s.arrow} ${isOpen ? s.open : ''}`} />
			</button>

			<div className={`${s.collapse} ${isOpen ? s.open : ''}`}>
				<div className={s.content}>
					<div className={s.list}>
						{items.map(col => (
							<div key={String(col.id)} className={s.item}>
								<div className={s.item__info}>
									<div className={s.item__title}>{col.title}</div>
									<div className={s.item__subtitle}>{col.subtitle}</div>
								</div>

								<Switch
									value="inactive"
									options={[
										{ value: 'active', label: 'Active' },
										{ value: 'inactive', label: 'Inactive' },
									]}
									onChange={nextValue => {
										if (nextValue === 'active') onActivate?.(col.id)
									}}
								/>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
